document.addEventListener('DOMContentLoaded', () => {

  const textIconlists = document.querySelectorAll('.nxa-block-text-iconlist');
  const mediaQuery = window.matchMedia('(min-width: 768px)');

  textIconlists.forEach(textIconlist => {
    const visibilityToggle = textIconlist.querySelector('.visibility-toggle');
    const visibilityToggleIcon = visibilityToggle.querySelector('svg');
    const visibilityToggleShowMore = visibilityToggle.querySelector('.show-more');
    const visibilityToggleShowLess = visibilityToggle.querySelector('.show-less');

    const updateUI = () => {
      if (mediaQuery.matches) {
        const items = textIconlist.querySelectorAll('.item');
        Array.from(items).forEach(item => item.querySelector('.body').removeAttribute('hidden'))
        const hiddenItems = Array.from(items).filter(item => {
          return item.classList.contains('hidden-on-mobile');
        });
        hiddenItems.forEach(item => {
          item.style.display = 'block';
        });

        visibilityToggle.style.display = 'none'
        visibilityToggleIcon.style.transform = '';
        visibilityToggleShowMore.style.display = '';
        visibilityToggleShowLess.style.display = 'none';
      } else {
        const items = textIconlist.querySelectorAll('.item');
        Array.from(items).forEach(item => item.querySelector('.body').setAttribute('hidden', ''))
        const hiddenItems = Array.from(items).filter(item => {
          return item.classList.contains('hidden-on-mobile');
        });
        hiddenItems.forEach(item => {
          item.style.display = 'none';
        });

        visibilityToggle.style.display = hiddenItems.length > 0 ? 'flex' : 'none'

        if (visibilityToggle && !visibilityToggle.dataset.clickBound) {
          visibilityToggle.dataset.clickBound = '1';
          let animating = false;
          const resetItemAndRemoveHandler = (item, handler) => {
            item.style.maxHeight = '';
            item.style.opacity = '';
            item.style.overflow = '';
            item.style.transition = '';
            item.style.pointerEvents = '';
            item.removeEventListener('transitionend', handler);
          };
          visibilityToggle.addEventListener('click', () => {
            if (mediaQuery.matches || animating) return;
            const hiddenItems = Array.from(textIconlist.querySelectorAll('.item')).filter(item => {
              return window.getComputedStyle(item).display === 'none';
            });
            if (hiddenItems.length > 0) {
              // Einblenden
              visibilityToggle.setAttribute('aria-expanded', 'true');
              visibilityToggleIcon.style.transform = 'scaleY(-1)';
              visibilityToggleShowMore.style.display = 'none';
              visibilityToggleShowLess.style.display = '';
              hiddenItems.forEach((item, index) => {
                animating = true;
                setTimeout(() => {
                  item.style.display = '';
                  item.style.maxHeight = '0';
                  item.style.opacity = '0';
                  item.style.overflow = 'hidden';
                  item.style.transition = 'max-height .3s ease, opacity .6s ease';
                  item.style.pointerEvents = 'none';
                  requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                      item.style.maxHeight = `${item.scrollHeight}px`;
                      item.style.opacity = '1';
                      const handler = (e) => {
                        if (e.propertyName !== 'opacity') return;
                        resetItemAndRemoveHandler(item, handler);
                        if (index === hiddenItems.length - 1) {
                          animating = false;
                        }
                      };
                      item.addEventListener('transitionend', handler);
                    });
                  });
                }, index * 100);
              });
            } else {
              // Ausblenden
              visibilityToggle.setAttribute('aria-expanded', 'false');
              visibilityToggleIcon.style.transform = '';
              visibilityToggleShowMore.style.display = '';
              visibilityToggleShowLess.style.display = 'none';
              const itemsToHide = Array.from(textIconlist.querySelectorAll('.item')).slice(5).reverse();
              itemsToHide.forEach((item, index) => {
                animating = true;
                setTimeout(() => {
                  item.style.maxHeight = `${item.scrollHeight}px`;
                  item.style.opacity = '1';
                  item.style.overflow = 'hidden';
                  item.style.transition = 'max-height .3s ease .3s, opacity .3s ease';
                  item.style.pointerEvents = 'none';
                  requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                      item.style.maxHeight = '0';
                      item.style.opacity = '0';
                      const handler = (e) => {
                        if (e.propertyName !== 'max-height') return;
                        resetItemAndRemoveHandler(item, handler);
                        item.style.display = 'none';
                        if (index === itemsToHide.length - 1) {
                          animating = false;
                        }
                      };
                      item.addEventListener('transitionend', handler);
                    });
                  });
                }, index * 100);
              });
            }
          });
        }
      }
    }
    updateUI();

    mediaQuery.addEventListener('change', updateUI);

    textIconlist.querySelectorAll('.item').forEach(item => {

      const header = item.querySelector('.header');
      const body = item.querySelector('.body');
      let isAnimating = false;

      header.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (!isAnimating) {
            toggleAccordion(header, body);
          }
        }
      });

      header.addEventListener('click', () => {
        if (!isAnimating) {
          toggleAccordion(header, body);
        }
      });

      function toggleAccordion(header, body) {

        if (mediaQuery.matches) {
          return;
        }

        if (header.getAttribute('aria-expanded') === 'true') {
          // open => close
          isAnimating = true;
          header.setAttribute('aria-expanded', 'false');
          body.style.maxHeight = `${body.scrollHeight}px`;
          requestAnimationFrame(() => {
            body.style.maxHeight = '0';
            body.style.opacity = '0';
          });
          body.addEventListener('transitionend', () => {
            body.style.maxHeight = '';
            body.style.opacity = '';
            isAnimating = false;
            body.hidden = true;
          }, {once: true});
        } else {
          // close => open
          isAnimating = true;
          body.hidden = false;
          header.setAttribute('aria-expanded', 'true');
          body.style.maxHeight = '0';
          body.style.opacity = '0';
          requestAnimationFrame(() => {
            body.style.maxHeight = `${body.scrollHeight}px`;
            body.style.opacity = '1';
          });
          body.addEventListener('transitionend', () => {
            body.style.maxHeight = '';
            body.style.opacity = '';
            isAnimating = false;
          }, {once: true});
        }
      }

    });

  });

});
